<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 6.375H3v1.5h18v-1.5ZM21 11.625H3v1.5h18v-1.5ZM13 16.875H3v1.5h10v-1.5Z"
      fill="currentColor"
    />
  </svg>
</template>
